/**
 * Created by Jie Gao on 2018-11-02.
 */
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineLite, Timeline, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GGGameConfig} from "../../GGGameConfig";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GGSoundConfig} from "../../GGSoundConfig";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class GGBigWinView extends BaseView {
    private _textContainer:PIXI.Sprite;
    private _dimmer:PIXI.Sprite;
    private _currentTimeLine:TimelineLite | null;
    private _layer:ScalableLayer;
    private _bwAnimations:PIXI.spine.Spine[] = [];
    private _bwTransitionAnimation:PIXI.spine.Spine | null;

    constructor() {
        super();
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.anchor.set(0.5, 0.5);
        this._dimmer.position.set(360, 360);
        this._dimmer.tint = 0X000000;
        this._dimmer.alpha = 0;
        this._layer = StageManager.getLayer(GGGameConfig.instance.LAYERS.BIG_WIN.name);
        this._layer.addChild(this._dimmer);
        //this._coinsFountain = new CoinsFountain(this._layer);
    }

    protected initAnimations():void {
        this._textContainer = new PIXI.Sprite();
        this._textContainer.anchor.set(0.5, 0.5);
        this._textContainer.position.set(360, 360);
        this._layer.addChild(this._textContainer);
    }

    protected onResize(resizeData:IResizeData):void {
        const screenWidth:number = resizeData.width;
        const screenHeight:number = resizeData.height;
        this._dimmer.width = screenWidth + 100;
        this._dimmer.height = screenHeight + 100;

        // #504
        if (this._bwAnimations.length > 0) {
            const bwAnimation: PIXI.spine.Spine = this._bwAnimations[this._bwAnimations.length - 1];

            if (NolimitApplication.isLandscape) {
                bwAnimation.scale.set(1);
            } else {
                bwAnimation.scale.set(0.8);
            }
        }
    }

    public startWinPresentation():void {
        this._currentTimeLine = new TimelineLite();
    }

    public getBigWinLevelAnimation(level:number, winRatioConfig:IWinRatioConfig):Timeline {
        if(level === 0) {
            this._bwAnimations = [];
        }
        if(this._bwTransitionAnimation) {
            this._bwTransitionAnimation.destroy();
        }
        const timeline:TimelineLite = new TimelineLite();
        const fs:number = 0.033;
        const bwAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(`BW_0${level + 1}`));
        bwAnimation.renderable = false;
        bwAnimation.visible = false;

        // #504
        if (NolimitApplication.isLandscape) {
            bwAnimation.scale.set(1);
        } else {
            bwAnimation.scale.set(0.8);
        }

        this._bwAnimations.push(bwAnimation);
        this._textContainer.addChild(bwAnimation);
        timeline.add([
            () => {
                bwAnimation.renderable = true;
                bwAnimation.visible = true;
                this._textContainer.visible = true;
                bwAnimation.state.setAnimation(0, "Intro", false);
                if(level > 1) {
                    this._bwTransitionAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset("Big_Win_Transition"));
                    this._textContainer.addChild(this._bwTransitionAnimation);
                    this._bwTransitionAnimation.scale.set(0.9 + (level - 2) * 0.2);
                    this._bwTransitionAnimation.state.setAnimation(0, "animation", false);
                }
            },
            this.updateBigWinLevelAnimation(level),
            TweenLite.to(this._dimmer, 0.1, {alpha : 0.8}),
            TweenLite.to(this._textContainer, 0.1, {alpha : 1}),
            TweenLite.to(this, winRatioConfig.duration, {alpha : 1})
        ], 0);
        timeline.add(() => {bwAnimation.state.setAnimation(0, "Idle", true);}, 1.1);
        if(level > 1) {
            timeline.add(() => {this._bwTransitionAnimation!.renderable = false}, 0.7 + (level - 2) * 0.2);
        }
        return timeline;
    }

    private updateBigWinLevelAnimation(level:number):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        if(level === 0) {
            return timeline;
        }

        timeline.add([
            () => {
                this._bwAnimations[level - 1].visible = false;
                this._bwAnimations[level - 1].renderable = false;
            },
            //TweenLite.fromTo(this._textContainer, 7 * 0.033, {alpha: 0}, {alpha: 100}),
            //TweenLite.fromTo(this._textContainer.scale, 7 * 0.033, {x: 2, y: 2}, {x: 1, y: 1})
        ], 0);
        return timeline;
    }

    public playEndingAnimation(level: number, isFSMode:boolean): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {GGGameModuleConfig.soundPlayer.playSoundEffect(GGSoundConfig.BIG_WIN_END)},
            TweenLite.to(this._dimmer, isFSMode ? 0.2 : 1, {alpha : 0.7}),
            TweenLite.to(this._textContainer, isFSMode ? 0.2 : 1, {alpha : 0})
        ]);
        timeline.add(TweenLite.to(this._dimmer, isFSMode?0.1:0.5, {alpha: 0}));
        timeline.add(() => this.reset());

        return timeline;
    }

    private reset():void {
        this._textContainer.scale.set(1, 1);
        this._bwAnimations.forEach((bwAnimation:PIXI.spine.Spine) => {
            bwAnimation.destroy();
        });
        this._bwAnimations = [];
        if(this._bwTransitionAnimation) {
            this._bwTransitionAnimation?.destroy();
            this._bwTransitionAnimation = null;
        }

        if(this._currentTimeLine && this._currentTimeLine.isActive()) {
            this._currentTimeLine.pause();
            this._currentTimeLine.kill();
        }
        this._currentTimeLine = null;
    }
}